import React, { useState } from "react";
import * as styles from "../../styles/components/product/feature-grid.module.css";
import Icon from "../icon";
import { Link } from "gatsby";
import { imageUrlFor } from "../../lib/image-url";
import { buildImageObj } from "../../lib/helpers";

const FeatureGrid = ({ features }) => {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div
          className={
            features.length === 1 ? styles.featuresSingle : styles.features
          }
        >
          {features.map((feature, index) => {
            return (
              <div
                key={index}
                className={
                  features.length === 1 ? styles.featureSingle : styles.feature
                }
              >
                {feature.icon && (
                  <img
                    src={imageUrlFor(buildImageObj(feature.icon))
                      .auto("format")
                      .url()}
                    alt={feature.title}
                  />
                )}
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                {feature?.cta?.type && (
                  <Link
                    to={
                      feature.cta.type === "internal"
                        ? feature.cta.slug
                        : feature.cta.link
                    }
                    className="link"
                  >
                    {feature.cta.title}
                    <Icon symbol="arrow-right" />
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FeatureGrid;
